import { render, staticRenderFns } from "./MovimentiMagazzino.vue?vue&type=template&id=340c1cba&"
import script from "./MovimentiMagazzino.vue?vue&type=script&lang=js&"
export * from "./MovimentiMagazzino.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports